var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEngineeringPanel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Tools_Icon_"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Tools_Icon_",
    "data-name": "Tools Icon ",
    clipPath: "url(#clip-Tools_Icon_)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1277",
    "data-name": "Group 1277",
    transform: "translate(0.045 0.046)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-screwdriver",
    "data-name": "Icon awesome-screwdriver",
    d: "M28.126,31.089l-5.862-4.5V23.708L18.405,19.85l1.577-1.577,3.859,3.859h2.884l4.461,5.948ZM9.913,14.631.507,5.442A1.721,1.721,0,0,1,.507,3L3.042.507a1.732,1.732,0,0,1,2.45,0l9.32,9.225Z",
    transform: "translate(0 31.187) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-wrench",
    "data-name": "Icon awesome-wrench",
    d: "M-.841-1.556A.563.563,0,0,1,.1-1.814L3.6,1.678l3.188-.531.531-3.188L3.824-5.534a.565.565,0,0,1,.266-.947A6.76,6.76,0,0,1,10.5-4.7a6.766,6.766,0,0,1,1.6,6.914L28.6,18.291a3.006,3.006,0,1,1-4.251,4.251L7.862,6.474A6.742,6.742,0,0,1,.94,4.866,6.761,6.761,0,0,1-.841-1.556Zm27.319,23.1a1.127,1.127,0,1,0-1.127-1.127A1.128,1.128,0,0,0,26.478,21.543Z",
    transform: "translate(0.996 6.634)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngineeringPanel);
export default __webpack_public_path__ + "static/media/EngineeringPanel.480ccf3aac9685b185a2f569138b1c30.svg";
export { ForwardRef as ReactComponent };